<nav class="menu">
  <ul class="menu_list">
    @for (menuItem of items(); track menuItem.title) {
      <li>
        <a
          class="menu_list__item"
          [routerLink]="menuItem['link']"
          [routerLinkActive]="'menu_list__item-active'"
        >
          <app-svg-icon
            class="menu_list__item-icon"
            [name]="menuItem.icon"
          />
          <span class="menu_list__item-title">{{ menuItem.title }}</span>

          <div class="menu_list__item-actions">
            @if (menuItemTemplate) {
              <ng-container
                [ngTemplateOutlet]="menuItemTemplate"
                [ngTemplateOutletContext]="{ $implicit: menuItem }"
              />
            }
          </div>
        </a>
      </li>
    }
  </ul>
</nav>
